import { Component, OnInit, Injector, Input } from '@angular/core';

import { ENTITY_REPORT_CONFIGURATION_OPTIONS } from '@core/constants';
import { GenericListComponent } from '@core/globals/generic-list/generic-list.component';
import { WcmModalsService } from '@core/globals/wcm-modals/wcm-modals.service';
import { WcmTableComponent } from '@core/globals/wcm-table/wcm-table.component';
import { omit } from '@core/helpers';
import { IGenericApi } from '@core/interfaces';
import { ObjectToolService } from '@core/services/object-tool.service';


@Component({
  selector: 'app-entities-detail-report-configurations',
  templateUrl: './entities-detail-report-configurations.component.html'
})
export class EntitiesDetailReportConfigurationsComponent extends GenericListComponent implements OnInit {
  @Input() public entity: any;

  public editionInProgress: boolean;
  public loadingItemAction: boolean;
  public typeOptions = ENTITY_REPORT_CONFIGURATION_OPTIONS;
  private api: IGenericApi;

  constructor(
    public injector: Injector,
    private wcmModalsService: WcmModalsService,
    private objectToolService: ObjectToolService
  ) {
    super(injector);
    // Api used for fetch, update and create
    this.api = this.apiShiva.report_configurations as IGenericApi;
  }

  public ngOnInit(): void {
    super.ngOnInit();

    this.localFilters.entity__code = this.entity ? this.entity.code : null;
  }

  public createItem(wcmTable) {
    wcmTable.items.unshift({
      editable: true,
      entity: this.entity,
      periodicity: 0
    });
    this.editionInProgress = true;
  }

  public edit(item) {
    // doing an item back up to be able to restore it if the user cancel the edition
    item.backup = {...item};
    item.editable = true;
    this.editionInProgress = true;
  }

  public cancelEdit(item, wcmTable) {
    // If the item has no id, it's from a creation, we just remove it from the list
    if (!item.id) {
      const itemIndex = wcmTable.items.indexOf(item);
      wcmTable.items.splice(itemIndex, 1);
    } else {
      // Otherwise, restoring the back up to cancel the edition and bring back the previous values.
      // We do a copy of the backup key before calling the replace function because the first step
      // in this function is to clear the given first object
      const backup = {...item.backup};
      this.objectToolService.replaceObjContent(item, backup);
    }
    this.editionInProgress = false;
  }

  public save(item, wcmTable: WcmTableComponent) {
    this.loadingItemAction = true;
    // removing the object attributes that we use locally for the edition
    const payload = omit(item, 'editable', 'backup');

    let promise;
    if (item.id) {
      promise = this.api.update(item.id, payload);
    } else {
      promise = this.api.create(payload);
    }

    promise
      .then(() => {
        wcmTable.refreshTable();
        this.editionInProgress = false;
      }).catch((err) => {
        Promise.reject(err);
      }).finally(() => {
        this.loadingItemAction = false;
      });
  }

  public confirmDelete(item, wcmTable) {
    const msgTitle = `Suppression d'une configuration de rapport`;
    const msgBody = `Confirmez-vous la suppression de la configuration de rapport ?`;
    this.wcmModalsService.confirm(msgTitle, msgBody, 'Confirmer', 'Annuler')
      .then(() => {
        this._delete(item, wcmTable);
      }, () => {});
  }

  public fetchCallback(res) {
    // In case the user was editing a line before filtering / ordering the table, we reset the edition state
    // to prevent disabling the action buttons forever !
    this.editionInProgress = false;
  }

  private _delete(item, wcmTable) {
    this.loadingItemAction = true;
    this.api.delete(item.id)
      .then(() => {
        wcmTable.refreshTable();
      }, err => {
        console.error('Erreur lors de la suppression de la configuration de rapport', err);
        this.toastr.error('Erreur lors de la suppression de la configuration de rapport, veuillez essayer à nouveau.');
      }).finally(() => {
        this.loadingItemAction = false;
      });
  }
}
